export interface LeaderboardEntry {
  processorUserId: number;
  processorName: string;
  completedCount: number;
  avgDurationSeconds: number;
  fastestDurationSeconds: number;
  totalStreamsProcessed: number;
  totalVerifiedAmount: number;
  fraudCatchCount: number;
  auditPassCount: number;
  auditConcernsCount: number;
  auditFailCount: number;
  auditedCount: number;
  qaIssueCount: number;
  qaIssueHighSevCount: number;
  firstCompletedDate: string | null;
  lastCompletedDate: string | null;
  activeDaysCount: number;
  currentStreakDays: number;
}

export interface LeaderboardResponse {
  entries: LeaderboardEntry[];
  daysBack: number;
}

// Candy Crush-style level thresholds based on composite score
export interface ProcessorLevel {
  level: number;
  name: string;
  minScore: number;
  color: string;
  icon: string;
  stars: number; // 1-3 stars within a level
}

export const PROCESSOR_LEVELS: ProcessorLevel[] = [
  { level: 1, name: 'Trainee',     minScore: 0,    color: '#8B8B8B', icon: '🌱', stars: 0 },
  { level: 2, name: 'Apprentice',  minScore: 50,   color: '#4CAF50', icon: '🔰', stars: 0 },
  { level: 3, name: 'Specialist',  minScore: 150,  color: '#2196F3', icon: '⭐', stars: 0 },
  { level: 4, name: 'Expert',      minScore: 300,  color: '#9C27B0', icon: '🏆', stars: 0 },
  { level: 5, name: 'Master',      minScore: 500,  color: '#FF9800', icon: '👑', stars: 0 },
  { level: 6, name: 'Legend',      minScore: 800,  color: '#F44336', icon: '🔥', stars: 0 },
];
